import {stateData, reduxState} from '../../values';

const initialState = {
    channels:       [],
    status:         stateData.state1,
    channelsEdit:   [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_channels){
        return {
            ...state,
            channels:   action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_channels){
        return {
            ...state,
            channelsEdit: action.payload
        }
    }
    return state
}
export default reducer